import React from 'react';
import './Load.css';

const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader-container">
                <div className="loader-spinner"></div>
            </div>
        </div>
    );
};

export default Loader;